import { useMemo, useState } from 'react'
import { Button, Input, Popover, Space } from 'antd'
import { FolderOpenOutlined } from '@ant-design/icons'
import {
  DocCategoryParentBrowsePanel,
  flattenDocCategoryTree,
  type DocCategoryTreeNode,
} from './DocCategoryParentBrowsePanel'
import './BrowsePopover.css'

type Props = {
  value?: number | null
  onChange?: (parentId: number | null) => void
  tree: DocCategoryTreeNode[]
  excludeIds?: Set<number>
  placeholder?: string
  disabled?: boolean
  subtreeHeight?: number
}

export function DocCategoryParentBrowseField({
  value,
  onChange,
  tree,
  excludeIds,
  placeholder = '顶级类型（不选上级）',
  disabled,
  subtreeHeight = 1,
}: Props) {
  const [open, setOpen] = useState(false)
  const flat = useMemo(() => flattenDocCategoryTree(tree), [tree])
  const label = value == null ? '' : flat.find((x) => x.id === value)?.path || flat.find((x) => x.id === value)?.name || ''

  return (
    <Space.Compact block>
      <Input readOnly disabled={disabled} placeholder={placeholder} value={label} />
      <Popover
        open={disabled ? false : open}
        onOpenChange={setOpen}
        trigger="click"
        placement="bottomLeft"
        overlayClassName="app-browse-popover"
        content={
          <div className="app-browse-popover-panel app-browse-popover-panel--category-parent">
            <DocCategoryParentBrowsePanel
              tree={tree}
              excludeIds={excludeIds}
              value={value}
              subtreeHeight={subtreeHeight}
              onChange={(id) => {
                onChange?.(id)
                setOpen(false)
              }}
            />
          </div>
        }
      >
        <Button icon={<FolderOpenOutlined />} disabled={disabled}>
          浏览
        </Button>
      </Popover>
      {value != null && !disabled ? (
        <Button onClick={() => onChange?.(null)}>清除</Button>
      ) : null}
    </Space.Compact>
  )
}
